module.exports = __webpack_public_path__ + "img/GAME_WORDFERRISWHEEL.e3216427.png";